import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const ContactContainer = styled(Container)`
  padding-top: 120px;
  padding-bottom: 80px;
`;

const SectionTitle = styled(Typography)`
  color: #fff;
  font-weight: 600;
  margin-bottom: 24px;
`;

const SectionText = styled(Typography)`
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
`;

const QRCodeImage = styled("img")`
  width: 200px;
  height: 200px;
  margin: 24px 0;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const Contact = () => {
  const sections = [
    {
      id: 1,
      title: "通过 Zelle 银行转账奉献",
      content: [
        "Zelle ID (电邮): give3cca@gmail.com",
        "请在 Zelle 转账的时候, 注明您的名字及电邮或邮寄地址, 以便我们寄收据给您。谢谢您的支持。",
        "Please indicate your name and email address or mailing address in the Zelle, so we can send out a receipt to you. Thank you for your financial support.",
      ],
      hasQRCode: true,
    },
    {
      id: 2,
      title: "通过支票奉献",
      content: [
        "支票抬头请写 3CCA。支票请寄到2257 Villa Maria Rd N, Claremont, CA 91711。",
        "Please make your check payable to 3CCA, and mail to 2257 Villa Maria Rd N, Claremont, CA 91711.",
        "请注明您的名字及电邮, 以便我们寄收据给您。谢谢您的支持。",
        "Please indicate your email address, so we can send out a receipt to you. Thank you for your financial support.",
      ],
    },
    {
      id: 3,
      title: "免税资格说明",
      content: [
        "3C 基督徒联盟（3CCA）已在美国注册为 501（c）（3） 非营利组织。 对3CCA的所有捐款，在法律允许的最大范围内均可抵税。",
        "3C Christian Alliance (3CCA) has registered as a 501(c)(3) nonprofit organization in the United States.  All donations to 3CCA are tax-deductible to the fullest extent allowed by law.",
      ],
    },
    {
      id: 4,
      title: "联系方式",
      content: ["电话: 626 662 4163", "邮箱: 3cchristianalliance@gmail.com"],
    },
  ];

  return (
    <Container
      maxWidth="lg"
      sx={{
        pt: { xs: 4, md: 6 },
        pb: { xs: 6, md: 8 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      {sections.map((section) => (
        <Box
          key={section.id}
          sx={{
            mb: { xs: 5, md: 4 },
            background: "rgba(0, 0, 0, 0.25)",
            backdropFilter: "blur(15px)",
            WebkitBackdropFilter: "blur(15px)",
            borderRadius: { xs: "16px", md: "24px" },
            border: "1px solid rgba(255, 255, 255, 0.2)",
            p: { xs: 3, sm: 4, md: 6 },
            mx: { xs: 1, sm: 2, md: 0 },
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            "&:last-child": { mb: 0 },
            transition: "all 0.3s ease",
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: { xs: "16px", md: "24px" },
              pointerEvents: "none",
            },
            // 移除 hover 效果
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "rgba(255, 255, 255, 0.95)",
              fontWeight: 600,
              mb: { xs: 2, md: 3 },
              fontSize: { xs: "1.25rem", sm: "1.4rem", md: "1.5rem" },
              lineHeight: 1.3,
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
              position: "relative",
              zIndex: 1,
            }}
          >
            {section.title}
          </Typography>

          {section.content.map((text, index) => (
            <Typography
              key={index}
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.85)",
                mb: { xs: 2, md: 1.5 },
                fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                lineHeight: { xs: 1.6, md: 1.8 },
                "&:last-of-type": { mb: section.hasQRCode ? 2 : 0 },
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                position: "relative",
                zIndex: 1,
              }}
            >
              {text}
            </Typography>
          ))}

          {section.hasQRCode && (
            <Box sx={{ mt: { xs: 2, md: 3 }, mb: { xs: 2, md: 3 } }}>
              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.85)",
                  mb: 1.5,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1rem" },
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                Zelle QR Code:
              </Typography>
              <Box
                component="img"
                src="images\other\Image_20250226173327.jpg"
                alt="Zelle QR Code"
                sx={{
                  width: { xs: "160px", sm: "180px", md: "200px" },
                  height: { xs: "160px", sm: "180px", md: "200px" },
                  borderRadius: { xs: "8px", md: "12px" },
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  display: "block",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              />
            </Box>
          )}
        </Box>
      ))}
    </Container>
  );
};

export default Contact;
